import styled from "@emotion/styled";

const Dimed = styled.div<{ opacity: number }>`
	opacity: ${({ opacity }) => opacity};
`;

export default Dimed;
